module.exports = __webpack_public_path__ + "img/push.b9a748bf.svg";